import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Navigation from "@/components/Navigation";
import Footer from "@/components/Footer";
import Home from "@/pages/Home";
import Programs from "@/pages/Programs";
import Gallery from "@/pages/Gallery";
import Partners from "@/pages/Partners";
import Contact from "@/pages/Contact";
import Donate from "@/pages/Donate";
import Shop from "@/pages/Shop";
import Checkout from "@/pages/Checkout";
import ThankYou from "@/pages/ThankYou";
import Admin from "@/pages/Admin";
import MerchDayFlyer from "@/pages/MerchDayFlyer";
import LinkHub from "@/pages/LinkHub";

function App() {
  return (
    <div className="App min-h-screen bg-white">
      <BrowserRouter>
        <Routes>
          {/* Standalone pages without navigation/footer */}
          <Route path="/merchday-flyer" element={<MerchDayFlyer />} />
          <Route path="/links" element={<LinkHub />} />
          <Route path="/linkhub" element={<LinkHub />} />
          
          {/* Main site routes with navigation/footer */}
          <Route path="/*" element={
            <>
              <Navigation />
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/programs" element={<Programs />} />
                <Route path="/gallery" element={<Gallery />} />
                <Route path="/partners" element={<Partners />} />
                <Route path="/shop" element={<Shop />} />
                <Route path="/checkout" element={<Checkout />} />
                <Route path="/thank-you" element={<ThankYou />} />
                <Route path="/admin" element={<Admin />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/donate" element={<Donate />} />
              </Routes>
              <Footer />
            </>
          } />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
